import React from 'react';
import { Bubble, AgentChip, ThinkingDots, AgentStatusRow } from './tutorialHelpers';

const ASK_QUERY =
  "What are the latest breakthroughs in room-temperature superconductors " +
  "and what do they mean for energy storage?";

const ASK_PRELIMINARY =
  "Recent work has produced hydrogen-rich compounds and novel copper-oxide " +
  "structures with reduced electrical resistance at higher temperatures than " +
  "previously achieved — a significant step toward practical applications.";

const ASK_FINAL =
  "Synthesizing 3 academic papers and current web sources: The most notable " +
  "2024 result involves a yttrium-barium-copper-oxide variant achieving " +
  "superconductivity at 213K (−60°C), a 40K improvement over prior records. " +
  "For energy storage, zero-resistance transmission lines could reduce grid " +
  "losses by ~15%, while superconducting magnetic energy storage (SMES) may " +
  "approach near-perfect round-trip efficiency. Commercialization remains " +
  "10–20 years out pending pressure and cooling requirements.";

const ASK_EVALUATION =
  "Accuracy: 9/10 — findings align with published literature. " +
  "Completeness: The 10–20 year commercialization estimate is well-supported " +
  "by current engineering constraints. Gap identified: Ambient-pressure " +
  "superconductor claims (LK-99 controversy) are absent. " +
  "Overall quality: High — suitable as a research starting point.";

export function AskDemoPanel({ step }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.6rem', width: '100%' }}>
      {step >= 1 && <Bubble align="right">{ASK_QUERY}</Bubble>}
      {step === 2 && (
        <Bubble color="#636cff">
          <AgentChip name="Orchestrator" color="#636cff" badge="Thinking" />
          <ThinkingDots />
        </Bubble>
      )}
      {step >= 3 && (
        <Bubble color="#636cff">
          <AgentChip name="Orchestrator" color="#636cff" badge="Concise" />
          {ASK_PRELIMINARY}
        </Bubble>
      )}
      {step >= 4 && (
        <div className="sdemo-enter" style={{
          padding: '0.5rem 0.75rem',
          border: '1px solid var(--border-color, #ddd)',
          borderRadius: '8px',
          backgroundColor: 'var(--bg-secondary, #f5f5f5)',
          fontSize: '0.82rem',
        }}>
          <div style={{
            fontWeight: 600, marginBottom: '4px',
            color: 'var(--text-secondary, #888)',
            fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.04em',
          }}>
            Background Research
          </div>
          <AgentStatusRow name="Generalist Agent" done={step >= 5} />
          <AgentStatusRow name="Researcher Agent" done={step >= 5} />
        </div>
      )}
      {step >= 6 && (
        <Bubble color="#28a745">
          <AgentChip name="Orchestrator" color="#636cff" badge="Expansive" badgeColor="#28a745" />
          {ASK_FINAL}
        </Bubble>
      )}
      {step >= 7 && (
        <div className="sdemo-enter" style={{
          padding: '0.65rem 0.9rem',
          border: '1px solid #f59e0b',
          borderRadius: '8px',
          backgroundColor: 'var(--bg-secondary, #f5f5f5)',
          fontSize: '0.82rem',
          lineHeight: 1.55,
        }}>
          <AgentChip name="Orchestrator" color="#636cff" badge="Evaluation" badgeColor="#f59e0b" />
          {ASK_EVALUATION}
        </div>
      )}
    </div>
  );
}
